import { render, staticRenderFns } from "./UiCardSlider.vue?vue&type=template&id=be24d4c0&scoped=true"
import script from "./UiCardSlider.vue?vue&type=script&lang=js"
export * from "./UiCardSlider.vue?vue&type=script&lang=js"
import style0 from "./UiCardSlider.vue?vue&type=style&index=0&id=be24d4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be24d4c0",
  null
  
)

export default component.exports